// work data

export const Work = [
    {
        id:1,//link
        name:"Expense Tracker",
        description:"React JS web app that enables expense tracking accounting for every month in a calendar year",
        tags:["react"],
        
        demo:"https://github.com/KeithArogo/Expense-Tracker",
        github:"https://github.com/KeithArogo/Expense-Tracker"
    },
    {
        id:2,
        name:"Stock price prediction with portfolio optimization",
        description:"Using Machine Learning methods to predict stock prices and output optimal portfolios using technical indicators and news sentiment as features.",
        tags:["Python","R","NumPy","Pandas","sklearn"],
        
        demo:"https://github.com/KeithArogo/Stock-Price-Prediction-with-Optimization",
        github:"https://github.com/KeithArogo/Stock-Price-Prediction-with-Optimization"
        
    },
    {
        id:3,
        name:"React Chat App",
        description:"A chat built using ReactJS hosted on Netlify enabling back and forth messaging between authorized users.",
        tags:["react","Netlify"],
        
        demo:"https://github.com/KeithArogo/Chat",
        github:"https://github.com/KeithArogo/Chat"
    },
    {
        id:4,
        name:"Q and A ChatBot",
        description:"A simple Question and Answer chatbot written in Python used to answer questions from a larger database",
        tags:["NLP","NLTK","Machine Learning"],
        
        demo:"https://github.com/KeithArogo/Q-and-A-Chatbot",
        github:"https://github.com/KeithArogo/Q-and-A-Chatbot"
       
    },{
        id:5,//link
        name:"Bird Classifier",
        description:"A web app with bird classification capabilities built using ML5 for machine learning and p5 in Javascript",
        tags:["ML5","Machine Learning","JavaScript","p5"],
        
        demo:"https://github.com/KeithArogo/Bird-Classifier",
        github:"https://github.com/KeithArogo/Bird-Classifier"
        
    },
    {
        id:6,
        name:"Stock Management App",
        description:"A web-based application to keep track of stock records, and provide reminders on low stock counts. Built using Python's Django Framework.",
        tags:["Python","Django","HTML/CSS"],
        
        demo:"https://github.com/Jiachenn99/DGSB-Stock-Management-Project",
        github:"https://github.com/Jiachenn99/DGSB-Stock-Management-Project"
        
    },
    {
        id:7,
        name:"Countdown Timer",
        description:"A simple countdown timer that shows the remaining duration to a particular target date. Measured in days, hours, minutes and seconds.",
        tags:["JavaScript","HTML","CSS"],
        
        demo:"https://github.com/KeithArogo/Timer-Countdown",
        github:"https://github.com/KeithArogo/Timer-Countdown"
        
    },
    
  
] 